export const ExitType = Object.freeze({
    'By Admin': 1,
    Customer: 2,
});
